export class Variables {
  public static STORAGE_AUTH = 'STORAGE_AUTH';
  public static USER_AUTH = 'USER_AUTH';
  public static USER_LOGIN = 'USER_LOGIN';
  public static USER_PREFERENCES = 'USER_PREFERENCES';
  public static SHOPPING_CART = 'SHOPPING_CART';
  public static PRODUCTS = 'PRODUCTS';
  public static PERMISSIONS = 'PERMISSIONS';
  public static ROLES = 'ROLES';
  public static MENU = 'MENU';
  public static STORAGE_AUTH_LADV = 'STORAGE_AUTH_LADV';
}
